import { useParams } from 'react-router-dom'
import Editform from '../components/Editform'
import Newform from '../components/Newform'

const Edit = (props) => {

  const {url,nomeSing,apiModel,enableSave,enableDelete,enableNew,baseUrl,MEDIA_URL,additionalFilter} = props

  const {id} = useParams()

  return (
    <>
      {id !== 'new' && <><Editform url={url} nomeSing={nomeSing} apiModel={apiModel} enableSave={enableSave} enableDelete={enableDelete} baseUrl={baseUrl} MEDIA_URL={MEDIA_URL} additionalFilter={additionalFilter} /></>}
      {id === 'new' && enableNew && <><Newform url={url} nomeSing={nomeSing} apiModel={apiModel} enableSave={enableSave} enableDelete={enableDelete} baseUrl={baseUrl} MEDIA_URL={MEDIA_URL} additionalFilter={additionalFilter} /></>}
    </>
  )
}

export default Edit